<script lang="ts">import { buildMarkdownItCtaRules, markdownItCtaPlugin } from "../plugins/markdown-it-cta-plugin";
import { cfgBrandTitle } from "@infinitro/config";
import MarkdownIt from "markdown-it";
import { onMount } from "svelte";
let { content = $bindable(), brandName = cfgBrandTitle() } = $props();
let renderedHtml = $state("");
const md = new MarkdownIt({
	html: true,
	breaks: true,
	linkify: true
});
md.use(markdownItCtaPlugin);
onMount(() => {
	content = content.replace(/%(domain|brand)%/g, `${brandName}`);
	renderedHtml = md.render(content);
});
</script>

{#if renderedHtml !== ''}
	<div class="markdown">
		{@html renderedHtml}
	</div>
{/if}
